import { RadioField, OrderJourneyContent } from '@sh24/ui-components'
import _ from 'lodash'
import getQuestionInfo from '../../utils/get-question-info'

const formatRegionName = (regionName) => {
  if (typeof regionName !== 'string') return ''

  const cleaned = regionName.replace(/_/g, ' ')
  return _.startCase(cleaned)
}

const PepReferralClinicsQuestion = ({
  question,
  contextKey,
  context,
  dispatch,
}) => {
  const selected = context[contextKey]
  const errors = context?.errors?.[contextKey] || []
  const { infoTop, infoBottom } = getQuestionInfo(context, question)

  const pepReferralClinics = context?.pepReferralClinics || []
  const pepReferralClinicsOptions = pepReferralClinics.map((clinic) => (
    {
      text: `${clinic.name} (${formatRegionName(clinic.region)})`,
      value: clinic.token,
      details: `${clinic.address}, ${clinic.postcode}`,
    }
  ))
  const handler = (e) => {
    dispatch(contextKey, e.target.value)
  }

  return (
    <>
      <OrderJourneyContent>
        <RadioField
          id={question.id}
          title={question.title}
          label={question.label}
          infoTop={infoTop}
          infoBottom={infoBottom}
          selected={selected}
          options={pepReferralClinicsOptions}
          onChange={handler}
          errors={errors}
        />
      </OrderJourneyContent>
    </>
  )
}

export default PepReferralClinicsQuestion
